export enum Role {
    CAS = 1,
    Helpdesk = 2,
    MinistryAdministrator = 3,
    MinistryCommittee = 4,
    CountyLeader = 5,
    CountyAdministrator = 6,
    CountyCommittee = 7,
    InstitutionPrincipal = 8,
    InstitutionAdministrator = 9,
    InstitutionCommittee = 10,
    Parent = 11,
};